<template>
	<div>
		<v-card>
			<v-card-title
				class="d-flex align-center"
			>
				<v-icon
					icon="$users"
					start
				/>
				<translate>Customers</translate>
				<v-spacer />
				<v-btn
					v-can="'user.create'"
					color="primary"
					variant="flat"
					prepend-icon="$plus"
					@click="window.location.href='/bo/users/view'"
				>
					<translate>Add Customer</translate>
				</v-btn>
			</v-card-title>
			<v-card-text v-can="'user.read'">
				<model-backend-table
					ref="usersTable"
					endpoint="/api/v0/users/overview"
					:sort-by="[{key: 'id', order:'desc'}]"
					:headers="headers"
					:items-per-page="25"
					:items-per-page-options="[25, 50, 100]"
				>
					<template
						v-for="header in headers"
						#[`item.${header.value}`]="{ item }"
						:key="header.value"
					>
						<a
							:href="`/bo/users/view?id=${item.id}`"
						>{{ item[header.value] }}</a>
					</template>
				</model-backend-table>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
export default {
	name: 'UsersOverview',

	computed: {
		headers () {
			return [
				{
					title: this.$gettext('Name'), value: 'name', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Address'), value: 'address', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Postcode'), value: 'postalCode', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('City'), value: 'city', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Domain'), value: 'domain', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('E-mail'), value: 'email', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Telephone Number'), value: 'phoneNumber', sortable: false, filterable: false,
				},
			];
		}
	}
};
</script>
